<template>
  <b-row class="mt-5" cols="1" cols-md="2" cols-lg="3">
    <b-col v-for="feature in list"
      :key="feature.id"
      class="py-1"
    >
      <b-media class="my-0">
        <template v-slot:aside>
          <div class="box">
            <font-awesome-icon
                class="m-1"
                size="lg"
                :icon="feature.icon"
            />
          </div>
        </template>
        <span> {{feature.description}} </span>
        <small v-if="feature.details">
          {{feature.details}}
        </small>
      </b-media>
    </b-col>
  </b-row>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSitemap,
  faFile,
  faDesktop,
  faUsers,
  faUser,
  faFilePdf,
  faImages,
  faDownload,
  faTicketAlt,
  faCheckCircle,
  faKey,
  faNetworkWired,
  faWindowMaximize,
  faCloud,
  faColumns,
  faBookReader,
  faChartLine,
  faCoins,
  faUserShield,
  faMobileAlt,
  faLock
} from '@fortawesome/free-solid-svg-icons'

library.add(faSitemap)
library.add(faFile)
library.add(faDesktop)
library.add(faUsers)
library.add(faUser)
library.add(faFilePdf)
library.add(faImages)
library.add(faDownload)
library.add(faTicketAlt)
library.add(faKey)
library.add(faNetworkWired)
library.add(faWindowMaximize)
library.add(faCloud)
library.add(faColumns)
library.add(faBookReader)
library.add(faChartLine)
library.add(faCoins)
library.add(faUserShield)
library.add(faMobileAlt)
library.add(faLock)
library.add(faCheckCircle)

export default {
  name: "Features",

  props: {
    list: {
      type: Array,
      default: null
    }
  },
}
</script>

<style scoped>
  .media {
    display: flex;
    align-items: flex-start;
  }

  span {
    line-height: 1.400rem;
  }

  .box {
    width: 28px;
  }

</style>
